import { render, staticRenderFns } from "./BoReportFinancial.vue?vue&type=template&id=79bda5e6&scoped=true&"
import script from "./BoReportFinancial.vue?vue&type=script&lang=js&"
export * from "./BoReportFinancial.vue?vue&type=script&lang=js&"
import style0 from "./BoReportFinancial.vue?vue&type=style&index=0&id=79bda5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bda5e6",
  null
  
)

export default component.exports